import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import {initReactI18next} from "react-i18next";

import translationAr from "./locales/ar/translation.json";
import translationENG from "./locales/eng/translation.json";

import translationRu from "./locales/ru/translation.json";
import translationZh from "./locales/zh/translation.json";

// the translations
const resources = {
  en: {
    translation: translationENG,
  },
  ar: {
    translation: translationAr,
  },
  ru: {
    translation: translationRu,
  },
  zh: {
    translation: translationZh,
  }
};

const language = localStorage.getItem("meras_lang");
if (!language) {
  localStorage.setItem("meras_lang", "en");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("meras_lang") || "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
